import { useState } from 'react';
import Modal from 'react-bootstrap/Modal';
import FloatingLabel from 'react-bootstrap/FloatingLabel';
import Form from 'react-bootstrap/Form';
import LoadingComponent from './../../widgets/LoadingComponent';
import { getData } from '../../api/ApiRest';



function DocumentoReEnvioCorreo(props) {
    const [loading, setLoading] = useState(false);
    const [correoDestino, setCorreoDestino] = useState('');

    const initForm = () => {
        console.log(props);
    }


    const enviarCorreo = (event) => {
        event.preventDefault();
        setLoading(true);



        getData('api/Cliente/Document/SendFactura', {
            id: props.DocumentSelect.documentId,
            Correo: correoDestino
        }).then(response => {
            alert('Enviado con exito');
            props.cerrarModal();
            console.log(response);
            setLoading(false);
        }, error => {
            setLoading(false);
            console.log(error);
            alert('Algo salio mal por favor verifica');
        })

    }


    return <Modal
        size='xl'
        show={props.Show}
        onShow={initForm}
        onHide={props.cerrarModal}>
        <Modal.Header closeButton>
            <Modal.Title>
                Re Envio de documento
            </Modal.Title>
        </Modal.Header>
        <Modal.Body>
            {<LoadingComponent Loading={loading} />}
            <Form onSubmit={enviarCorreo}>
                <div className='row'>
                    <div className='col-md-4'>
                        <FloatingLabel
                            controlId="DocumentRef"
                            label="Documento"
                            className="mb-3"
                        >
                            <Form.Control
                                size='sm'
                                autoComplete='off'
                                value={props.DocumentSelect.typeDocument_Prefix + '-' + props.DocumentSelect.consecutive}
                                readOnly={true}
                            />
                        </FloatingLabel>
                    </div>

                    <div className='col-md-6'>
                        <FloatingLabel
                            controlId="Email"
                            label="Email"
                            className="mb-3"
                        >
                            <Form.Control
                                size='sm'
                                required={true}
                                type='email'
                                autoComplete='off'
                                value={correoDestino}
                                onChange={e => setCorreoDestino(e.target.value)}
                            />
                        </FloatingLabel>
                    </div>

                    <div className='col-md-2'>
                        <button type='submit' className='btn btn-primary'>
                            Enviar
                        </button>
                    </div>

                </div>
            </Form>


        </Modal.Body>
    </Modal>

}


export default DocumentoReEnvioCorreo;